<div class="clearfix">
  <h5>{{'project.order'|translate}}{{'ui.state'|translate|lowercase}}</h5>
  <table class="table table-sm table-borderless w-auto">
    <tr *ngIf="orderStatus.completed">
      <td>{{'ui.finished'|translate}}</td>
      <td class="text-right"><b>{{orderStatus.completed}}</b></td>
      <td>({{orderStatus.completedPercentage | float:1}}%)</td>
    </tr>
    <tr *ngIf="orderStatus.partlyDelivered">
      <td>{{'ui.partly'|translate}} {{'order.delivered'|translate|lowercase}}</td>
      <td class="text-right"><b>{{orderStatus.partlyDelivered}}</b></td>
      <td>({{orderStatus.partlyDeliveredPercentage | float:1}}%)</td>
    </tr>
    <tr *ngIf="orderStatus.notStarted">
      <td>{{'ui.not-yet-started'|translate}}</td>
      <td class="text-right"><b>{{orderStatus.notStarted}}</b></td>
      <td>({{orderStatus.notStartedPercentage | float:1}}%)</td>
    </tr>
    <tr><td colspan="3">&nbsp;</td></tr>
    <tr *ngIf="orderStatus.onCall">
      <td>{{'order.on-call'|translate}}</td>
      <td class="text-right"><b>{{orderStatus.onCall}}</b></td>
      <td></td>
    </tr>
    <tr *ngIf="orderStatus.receiptsCount">
      <td>{{'order.production'|translate}}{{'production.receipts'|translate|lowercase}}</td>
      <td class="text-right"><b>{{orderStatus.receiptsCount}}</b></td>
      <td></td>
    </tr>
  </table>
</div>
